import React, { useState } from 'react';
import styles from './LeftPanel.module.scss';
import ProfleCard from '../ProfileCard/Profliecard';
import { BASIC_CONTENT } from '../../App.constant';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


const MenuItems = ['home', 'about', 'resume', 'contact'];


// eslint-disable-next-line react/prop-types
function LeftPanel({ activeTab, setActiveTab }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleScroll = (e, tab) => {
    e.preventDefault();
    setActiveTab(tab);
    const targetId = e.currentTarget.getAttribute('href').substring(1);
    console.log(document);
    const targetElement = document.getElementById(targetId);
    window.history.pushState(null, null, `#${targetId}`);
    targetElement?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleClose = () => {
    setAnchorEl(null)
  };


  return (
    <header className={styles.LeftPanelWrapper}>
      <div className={styles.leftPanelContainer}>
        <ProfleCard src={BASIC_CONTENT.profilePic} name={BASIC_CONTENT.name} />
        <div className={styles.navContaienr}>
          <div className={styles.hamburgerMenu}>
            <FontAwesomeIcon icon={isOpen ? faTimes : faBars} size="2x" onClick={(e) => setAnchorEl(e.currentTarget)} />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={isOpen}
              className={styles.menuContainer}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              {
                MenuItems.map((value) => (
                  <MenuItem key={value} className={styles.hamburgerMenuList}>
                    <a key={value} href={`#${value}`} onClick={(e) => handleScroll(e, value)} className={activeTab === value ? styles.active : ''}>{value}</a>
                  </MenuItem>
                ))
              }
            </Menu>
          </div>
          {
          <div className={styles.menuList}>
            {
            MenuItems.map((value) => (
              <a key={value} href={`#${value}`} onClick={(e) => handleScroll(e, value)} className={activeTab === value ? styles.active : ''}>{value}</a>
            ))
           }
          </div>
          }
        </div>
      </div>
    </header>
  );
}

export default LeftPanel;
